import { isProdEnv } from '@/utils/isProdEnv'
import * as Sentry from '@sentry/vue'
import type { App } from 'vue'

const integrations = [Sentry.browserTracingIntegration(), Sentry.replayIntegration()]

export default function sentryPlugin(app: App): void {
  const dsn = import.meta.env.VITE_SENTRY_DSN

  if (!dsn) {
    console.log('Sentry is not enabled: VITE_SENTRY_DSN is not set.')
    return
  }

  const isProd = isProdEnv()

  Sentry.init({
    app,
    dsn,
    integrations,
    environment: isProd ? 'production' : 'development',
    tracePropagationTargets: [import.meta.env.VITE_API_BASE_URL],
    propagateTraceparent: true,
    tracesSampleRate: 0.1,
    // Session replay is the expensive one and dev sessions are not worth recording.
    // Error replays stay on everywhere because they are low volume and high signal.
    replaysSessionSampleRate: isProd ? 0.1 : 0,
    replaysOnErrorSampleRate: 1.0,
  })
}
